import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { IMetaAdsConnection } from '../../extViewmodels/sdk/models/Ads';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'getMetaAdsProvider';

export const useGetMetaAdsProvider = ({
	impersonationContext,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IMetaAdsConnection>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'ads/providers/meta',
				}),
				'GET'
			);
		},
		enabled,
		queryKey: [BASE_QUERY_KEY, impersonationContext],
		refetchOnWindowFocus: false,
	});
};

export const invalidateMetaAdsProvider = ({
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, impersonationContext] });
};
